import React from 'react';
import { MoveLeftIcon } from './icons/MoveLeftIcon';

const CcusTitle = () => {
  return <div className='ccus-title'>CCUS入力情報</div>;
};

export const CcusTitleBlock = ({ onClick, disabled = false }) => {
  return (
    <React.Fragment>
      <CcusTitle />
      {onClick && (
        <button
          className='btn ccus-transcription-btn'
          disabled={disabled}
          onClick={onClick}
        >
          全て転記
        </button>
      )}
    </React.Fragment>
  );
};

export const CcusLineComponent = ({ children, ...rest }) => {
  return (
    <React.Fragment>
      <div className='form-list__element-ccus-line ' {...rest}>
        <MoveLeftIcon className='form-list__element-ccus-icon' />
        <div className='form-list__element-ccus-component'>{children}</div>
      </div>
    </React.Fragment>
  );
};

export const CcusBlockComponent = ({ components = null, ...rest }) => {
  return (
    <React.Fragment>
      <div
        className='form-list__element-ccus-line form-list__element-ccus-line--cursor-default'
        {...rest}
      >
        {components && (
          <div className='form-list__element-ccus-component-block'>
            {components.map((component, index) => {
              return (
                <div
                  className='form-list__element-ccus-component-block-line'
                  key={index}
                >
                  {component}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/components/CcusFormComponent.jsx